import { Role } from "./types/interfaces";
import { LineOfBusiness } from "../app/types";

/**
 * Maps roles to their claim type category using LineOfBusiness.
 * Roles within the same category (e.g. WC US and WC Canada) are treated
 * as a single line of business. Admin (WC_CLAIM_PRODUCT_GROUP) grants
 * access to all categories and is handled separately.
 *
 * When adding new claim types or country variants, add entries here.
 */
export const ROLE_TO_CLAIM_CATEGORY: Record<string, LineOfBusiness> = {
  [Role.WC_CLAIM_USER]: LineOfBusiness.WORKERS_COMPENSATION,
  [Role.WC_CLAIM_USER_LIMITED]: LineOfBusiness.WORKERS_COMPENSATION,
  [Role.WC_CLAIM_CANADA_USER]: LineOfBusiness.WORKERS_COMPENSATION,
  [Role.CARGO_CLAIM_USER]: LineOfBusiness.CARGO,
  [Role.IPL_CLAIM_USER]: LineOfBusiness.IPL,
};

/**
 * Returns the set of distinct claim type categories the user has access to.
 * Admin role grants access to all categories.
 */
export const getUserClaimCategories = (roles: Role[]): Set<LineOfBusiness> => {
  if (roles.includes(Role.WC_CLAIM_PRODUCT_GROUP)) {
    return new Set(Object.values(LineOfBusiness));
  }
  const categories = new Set<LineOfBusiness>();
  for (const role of roles) {
    const category = ROLE_TO_CLAIM_CATEGORY[role];
    if (category) {
      categories.add(category);
    }
  }
  return categories;
};
